import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function objectPositionStyle(
  photo:
    | { focal_point_x?: number | null; focal_point_y?: number | null }
    | null
    | undefined,
): string {
  const x = photo?.focal_point_x ?? 50
  const y = photo?.focal_point_y ?? 50
  return `${x}% ${y}%`
}
